<template>
    <div>
        <div class="login">
            <div>
                <div>登录账号</div>
                <div>
                    <img src="../../assets/logo.jpg">
                </div>
                <div class="pointer" @click="register">新用户注册</div>
                <div>还没有账号？立即注册</div>
            </div>
            <div>
                <div class="tit c333 fz14">手机号</div>
                <div class="input">
                    <el-input style="width: 100%;" placeholder="输入用户手机号" v-model="phone"></el-input>
                </div>
                <div class="tit c333 fz14">密码</div>
                <div class="input">
                    <el-input placeholder="输入用户密码" v-model="passWord" show-password></el-input>
                </div>
                <div class="pointer" @click="login2">登录</div>
                <div>
                    <div>
                        <el-checkbox v-model="checked"><span class="fz12">登录即代表同意<span class="blue">《法律声明》</span></span>
                        </el-checkbox>
                    </div>
                    <div class="pointer" @click="goRouter('/forget_pwd')">忘记密码？</div>
                </div>
            </div>
        </div>
        <div class="mark" v-show="showUser"></div>
        <div class="userList" v-show="showUser">
            <div>
                <div>请选择您的公司</div>
                <div class="pointer" @click="loginClose"><i class="el-icon-close" style="cursor: pointer;"></i></div>
            </div>
            <div>
                <div>
                    <el-radio-group v-model="radio">
                        <div class="item" v-for="(item,index) in userList">
                            <el-radio :label="index">
                                <span class="c666 fz12">{{item.companyName}}</span>
                            </el-radio>
                        </div>
                    </el-radio-group>
                </div>
            </div>
            <div @click="loginCofim">确定</div>
        </div>
    </div>
</template>

<script>
    import md5 from 'js-md5';
    export default {
        name: 'Login',
        data() {
            return {
                phone: '',
                passWord: '',
                check: true,
                logoImgs: '',

                userId: null,
                userList: [],
                showUser: false,
                item: null,
                isMain: null,

                radio: '',

                checked: false
            }
        },
        methods: {
            loginClose: function() {
                this.radio = '';
                this.userId = null;
                this.item = null;
                this.isMain = null;
                this.showUser = false;
            },
            loginIs: function(item) {
                this.userId = item.userId;
                this.item = item;
                this.isMain = item.isMain.toString();
                this.login(this.item.telnum, this.item.pwd, null, this.userId, this.item.isPerson)
            },
            loginCofim: function() {
                if (this.radio === 0) {

                } else {
                    if (!this.radio) {
                        this.$message({
                            message: '请选择账号',
                            type: 'warning'
                        });
                        return
                    }
                }
                this.loginIs(this.userList[this.radio])
            },
            //忘记密码
            forget: function() {
                this.$router.push({
                    path: '/forget'
                })
            },
            //注册
            register: function() {
                this.$router.replace({
                    path: '/register'
                })
            },
            //查看法律声明
            goLegalnotice: function() {
                this.$router.push({
                    path: '/legalnotice'
                })
            },
            //同意法律声明
            isCheck: function() {
                var that = this;
                that.check = !that.check;
            },
            login2: function() {
                var that = this;
                var reg = /^1[3456789]\d{9}$/;

                if (!that.phone) {
                    this.$message({
                        message: '请输入手机号',
                        type: 'warning'
                    });
                    return;
                }
                if (that.phone.length != 11 || reg.test(this.phone) == false) {
                    this.$message({
                        message: '手机号码格式不正确，请检查',
                        type: 'warning'
                    });
                    return;
                }
                if (!that.passWord) {
                    this.$message({
                        message: '请输入密码',
                        type: 'warning'
                    });
                    return;
                }
                if (!that.checked) {
                    this.$message({
                        message: '您还没有同意法律声明',
                        type: 'warning'
                    });
                    return false;
                }

                let params = {
                    telnum: that.phone,
                    pwd: md5(that.passWord),
                    // pwd: '0ebd794480f3c5cbe28ad7c181fddd7d',
                    clientId: '',
                }

                this.request({
                    method: 'post',
                    url: this.$store.state.httpUrl + "mobileInterf/loginMultipleAccounts",
                    params
                }).then(res => {
                    if (res.status == 200) {
                        if (res.flag == 1) {
                            that.userList = res.data;
                            that.showUser = true;
                            return;
                        }
                        sessionStorage.setItem("isLogin", "1");
                        sessionStorage.setItem("isMain", 1);
                        sessionStorage.setItem("permission", res.data.userType);
                        that.$store.state.permission = res.data.userType;

                        sessionStorage.setItem("isNotCertified", res.data.isNotCertified); //认证字段
                        sessionStorage.setItem("isNotCertifiedPerson", res.data
                            .isNotCertifiedPerson); //认证字段
                        that.$store.state.isNotCertified = res.data.isNotCertified;
                        that.$store.state.isNotCertifiedPerson = res.data.isNotCertifiedPerson;

                        sessionStorage.setItem("organizationId", "");
                        sessionStorage.setItem("companyName", "");

                        // 0未提交公司信息1代表公司信息已填写.2认证通过,3认证失败
                        if (res.data.isNotCertified == '2' || res.data.isNotCertifiedPerson == '6') {
                            sessionStorage.setItem("companyName", res.data.companyName); //认证字段
                            if (res.data.userType == '2') {
                                sessionStorage.setItem("organizationId", res.data
                                    .orgcode); //认证字段
                            } else {
                                sessionStorage.setItem("organizationId", res.data.org); //认证字段
                            }
                        } else {
                            sessionStorage.setItem("companyName", "");
                            sessionStorage.setItem("organizationId", "");
                        }

                        sessionStorage.setItem("state", JSON.stringify(that.$store.state));

                        sessionStorage.setItem("userId", res.data.userId);
                        sessionStorage.setItem("nickname", res.data.nickname);
                        sessionStorage.setItem("phone", that.phone);
                        sessionStorage.setItem("pwd", md5(that.passWord));

                        that.$router.push({
                            path: '/'
                        })
                    } else {
                        that.$message.error(res.msg);
                    }
                });
            },
            //登录
            login: function(tleNum, psw, clientid, userId, isPerson) {
                var that = this;

                let url = 'mobileInterf/loginUser';
                if (isPerson == '6') {
                    url = 'mobileInterf/loginUserPerson';
                }

                let params = {
                    userAccount: userId,
                    telnum: tleNum,
                    pwd: psw,
                    clientId: ''
                }

                this.request({
                    method: 'post',
                    url: this.$store.state.httpUrl + url,
                    params
                }).then(res => {
                    if (res.status == '200') {
                        sessionStorage.setItem("telnum", that.phone);

                        sessionStorage.setItem("isMain", that.isMain);
                        sessionStorage.setItem("isLogin", "1");
                        
                        if (isPerson == 6) {
                        	sessionStorage.setItem("permission", '2');
                        	that.$store.state.permission = '2';
                        } else {
                        	sessionStorage.setItem("permission", res.data.userType);
                        	that.$store.state.permission = res.data.userType;
                        	
                        }

                        sessionStorage.setItem("isNotCertified", res.data.isNotCertified); //认证字段
                        sessionStorage.setItem("isNotCertifiedPerson", res.data
                            .isNotCertifiedPerson); //认证字段
                        that.$store.state.isNotCertified = res.data.isNotCertified;
                        that.$store.state.isNotCertifiedPerson = res.data.isNotCertifiedPerson;

                        sessionStorage.setItem("organizationId", "");
                        sessionStorage.setItem("companyName", "");
                        if (isPerson == '2') {
                            sessionStorage.setItem("isPerson", isPerson);
                            that.$store.state.isPerson = isPerson;
                        }
                        if (isPerson == '6') {
                            sessionStorage.setItem("isPerson", isPerson);
                            that.$store.state.isPerson = isPerson;
                        }

                        // 0未提交公司信息1代表公司信息已填写.2认证通过,3认证失败
                        if (res.data.isNotCertified == '2' || res.data.isNotCertifiedPerson == '6') {
                            sessionStorage.setItem("companyName", res.data.companyName); //认证字段
                            if (res.data.userType == '2') {
                                sessionStorage.setItem("organizationId", res.data
                                    .orgcode); //认证字段
                            } else {
                                sessionStorage.setItem("organizationId", res.data.org); //认证字段
                            }
                        } else {
                            sessionStorage.setItem("companyName", "");
                            sessionStorage.setItem("organizationId", "");
                        }

                        sessionStorage.setItem("state", JSON.stringify(that.$store.state));

                        sessionStorage.setItem("userId", userId);
                        sessionStorage.setItem("nickname", res.data.nickname);
                        sessionStorage.setItem("phone", tleNum);
                        sessionStorage.setItem("pwd", md5(that.passWord));

                        that.$router.push({
                            path: '/'
                        })

                    } else {
                        that.$message.error(res.msg);
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .login {
        width: 680px;
        height: 380px;
        margin: 0 auto;
        margin-top: 90px;
        background: #FFFFFF;
        box-shadow: 0px 1px 7px 0px rgba(58, 138, 250, 0.35);
        border-radius: 15px;
        display: flex;
        box-sizing: border-box;
    }

    .login div {
        box-sizing: border-box;
    }

    .login>div:nth-child(1) {
        width: 280px;
        height: 380px;
        background: #D50000;
        border-radius: 15px;
        padding: 0 28px;
        background: url(../../assets/login_bg.png) no-repeat;
        background-size: 100% 100%;
    }

    .login>div:nth-child(1)>div {
        text-align: center;
    }

    .login>div:nth-child(1)>div:nth-child(1) {
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
        padding-bottom: 20px;
        margin-top: 58px;
        position: relative;
    }

    .login>div:nth-child(1)>div:nth-child(1)::before {
        content: ' ';
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        height: 1px;
        background: #FFFFFF;
        opacity: 0.33;
    }

    .login>div:nth-child(1)>div:nth-child(2)>img {
        width: 100px;
        height: 28px;
        margin-top: 80px;
    }

    .login>div:nth-child(1)>div:nth-child(3) {
        width: 160px;
        height: 42px;
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid #FFFFFF;
        border-radius: 8px;
        line-height: 36px;
        font-size: 14px;
        color: #FFFFFF;
        margin: 0 auto;
        margin-top: 28px;
    }

    .login>div:nth-child(1)>div:nth-child(4) {
        font-size: 14px;
        font-weight: 300;
        color: #FFFFFF;
        margin-top: 18px;
    }

    .login>div:nth-child(2) {
        width: 400px;
        height: 380px;
        background: #FFFFFF;
        padding: 10px 36px;
        border-radius: 15px;
    }

    .login>div:nth-child(2)>.input {
        width: 100%;
    }

    .login>div:nth-child(2)>.tit {
        line-height: 50px;
        text-align: left;
    }

    .login>div:nth-child(2)>div:nth-child(5) {
        width: 328px;
        height: 48px;
        background: #D50000;
        border-radius: 5px;
        line-height: 48px;
        font-size: 14px;
        color: #FFFFFF;
        margin-top: 42px;
    }

    .login>div:nth-child(2)>div:nth-child(6) {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .login>div:nth-child(2)>div:nth-child(6)>div:nth-child(2) {
        font-size: 12px;
        color: #D50000;
        line-height: 22px;
    }

    .mark {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .userList {
        width: 400px;
        height: 346px;
        background: #FFFFFF;
        box-shadow: 0px 1px 7px 0px rgba(58, 138, 250, 0.35);
        border-radius: 15px;
        position: fixed;
        top: 210px;
        left: calc(50% - 200px);
        z-index: 9;
        overflow: hidden;
    }

    .userList>div {
        box-sizing: border-box;
    }

    .userList>div:nth-child(1) {
        background: #D50000;
        height: 36px;
        line-height: 36px;
        display: flex;
        justify-content: space-between;
        color: #FFFFFF;
        padding: 0 20px;
    }

    .userList>div:nth-child(2) {
        padding: 20px;
    }

    .userList>div:nth-child(2)>div {
        height: 210px;
        background: #F4F7FF;
        border-radius: 10px;
        overflow-y: auto;
        padding: 14px;
        box-sizing: border-box;
        text-align: left;
    }

    .userList>div:nth-child(2)>div .item {
        margin-bottom: 14px;
    }

    .userList>div:nth-child(3) {
        width: 230px;
        height: 40px;
        background: #D50000;
        border-radius: 5px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        margin: 0 auto;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue